<div class="container" fxLayout="row" fxLayout.lt-sm="column">
  <fal-my-providers [fxFlex]="!questionsBillingInsurance ? 100 : 50" *ngIf="myProviders" [link]="myProviders.link"></fal-my-providers>
  <div class="divider" *ngIf="myProviders && questionsBillingInsurance" fxShow fxHide.lt-sm></div>
  <div class="divider horizontal" *ngIf="myProviders && questionsBillingInsurance" fxHide fxShow.lt-sm></div>
  <fal-questions-billing-insurance
    [fxFlex]="!myProviders ? 100 : 50"
    *ngIf="questionsBillingInsurance"
    [link]="questionsBillingInsurance.link"
    [target]="questionsBillingInsurance.target"
  ></fal-questions-billing-insurance>
</div>
